import { useMemo } from 'react';
import { useRoutes } from 'react-router-dom';

import { useIsFactor, useIsPayee, useIsPayor } from 'app/api/hooks/core/v1/auth/user';
import { UserRoles } from 'app/constants/user';
import { useIsRole, useIsTriumphInternal } from 'app/state/AuthContext/hooks';

import { useGetAdminRoutes } from './admin/useAdminRoutes';
import { useGetFactorRoutes } from './factor/useGetFactorRoutes';
import { useGetMainRoutes } from './main/useGetMainRoutes';
import { useGetPayeeRoutes } from './payee/usePayeeRoutes';
import { useGetPayorRoutes } from './payor/usePayorRoutes';

export const useAppRoutes = () => {
  const isAdmin = useIsTriumphInternal();
  const isFactor = useIsFactor();
  const isPayee = useIsPayee();
  const isPayor = useIsPayor();

  const adminRoutes = useGetAdminRoutes();
  const factorRoutes = useGetFactorRoutes();
  const mainRoutes = useGetMainRoutes();
  const payeeRoutes = useGetPayeeRoutes();
  const payorRoutes = useGetPayorRoutes();

  const isIbexCsr = useIsRole(UserRoles.IbexCsr);
  const isNoaAuditor = useIsRole(UserRoles.NoaAuditIbex);
  const isNoaProcessor = useIsRole(UserRoles.NoaIBEX);
  const isNoaProcessorManager = useIsRole(UserRoles.NoaManagerIBEX);

  const routeObjects = useMemo(() => {
    const routes = [
      ...mainRoutes,
    ];

    if (isAdmin || isIbexCsr || isNoaProcessor || isNoaAuditor || isNoaProcessorManager) {
      routes.push(...adminRoutes);
    }

    if (isFactor) {
      routes.push(...factorRoutes);
    }

    if (isPayee) {
      routes.push(...payeeRoutes);
    }

    if (isPayor) {
      routes.push(...payorRoutes);
    }

    return routes;
  },
  [
    adminRoutes,
    factorRoutes,
    isAdmin,
    isFactor,
    isIbexCsr,
    isNoaAuditor,
    isNoaProcessor,
    isNoaProcessorManager,
    isPayee,
    isPayor,
    mainRoutes,
    payeeRoutes,
    payorRoutes,
  ]);

  return useRoutes(routeObjects);
};
